angular.module('substoreApp')

    .factory('uipartnerserviceAce', ['$resource', function ($resource) {
        return $resource('../../uiservice/ace/:methodName?t=:cacheSlayer',
            {
                cacheSlayer: function () {
                    return (new Date().getTime() + Math.random()).toString(16);
                }
            },
            {
                productConfigurations: {method: 'GET', params: {methodName: 'productConfigurations'}}
            }
        );
    }])

    .service('partnerFeatureAce', [ "sessionData", "uipartnerserviceAce", function (sessionData, uipartnerserviceAce) {

        return {
            templates: {
                productdetails: { group: "partner/ace/templates/productdetailsgroup.html" }
            },
            actions: {
                productdetails: {
                    dialog: function (scope) {
                        scope.selection.ordered = -1; // we do not want preselection
                        scope.selection.apply();

                        scope.ace = {
                            priceList: null,
                            paymentIntervalNames: {},
                            options: {
                                manufacturers: null,
                                devices: null,
                                insuranceClasses: null,
                                paymentIntervals: null
                            },
                            selection: {
                                manufacturerName: "",
                                deviceId: "",
                                insuranceClassId: "",
                                paymentInterval: "",
                                tariff: null
                            },
                            maps: {
                                manufacturers: { },
                                devices: { },
                                insuranceClasses: { }
                            },
                            getPaymentIntervalName: function (value) {
                                return this.paymentIntervalNames[value];
                            },
                            applyFilter: function (kind) {
                                // reset lists as predefined
                                switch (kind) {
                                    case "manufacturers":
                                        if (this.selection.manufacturerName)
                                            this.options.devices = this.maps.manufacturers[this.selection.manufacturerName].deviceList.device;
                                        else
                                            this.options.devices = null;
                                        this.selection.deviceId = "";
                                    // fallthrough intended
                                    case "devices":
                                        this.options.insuranceClasses = null;
                                        this.selection.insuranceClassId = "";
                                    // fallthrough intended
                                    case "insuranceClasses":
                                        this.options.paymentIntervals = null;
                                        this.selection.paymentInterval = "";
                                }

                                // calculate selection options and determine actual tariff
                                var tariffs = [ ];
                                this.selection.tariff = null;

                                if (this.selection.deviceId) {
                                    // calculate eligible tariffs depending on actual selection
                                    var device = this.selection.deviceId && this.maps.devices[this.selection.deviceId];
                                    if (device)
                                        for (var i = 0; i < this.priceList.tariff.length; i++) {
                                            var tariff = this.priceList.tariff[i];
                                            if (tariff.deviceClassId === device.deviceClassId)
                                                tariffs.push(tariff);
                                        }

                                    // derive unique lists from eligible tariffs into options
                                    var insuranceClasses = this.options.insuranceClasses = [];
                                    var paymentIntervals = this.options.paymentIntervals = [];

                                    for (var i = 0; i < tariffs.length; i++) {
                                        var tariff = tariffs[i];

                                        var insuranceClass = this.maps.insuranceClasses[tariff.insuranceClassId];
                                        if (insuranceClasses.indexOf(insuranceClass) < 0)
                                            insuranceClasses.push(insuranceClass);

                                        if (this.selection.insuranceClassId
                                            && (paymentIntervals.indexOf(tariff.paymentInterval) < 0)
                                            && (tariff.insuranceClassId === this.selection.insuranceClassId || !this.selection.insuranceClassId))
                                            paymentIntervals.push(tariff.paymentInterval);

                                        if (tariff.insuranceClassId === this.selection.insuranceClassId && tariff.paymentInterval === this.selection.paymentInterval)
                                            this.selection.tariff = tariff;
                                    }
                                }

                                // propagate selection to visible fields
                                scope.selection.subscriptionTemplateId = (this.selection.tariff ? this.selection.tariff.tariffId : null);
                                scope.selection.apply();
                            }
                        };

                        uipartnerserviceAce.productConfigurations({sessionId: sessionData.sessionId},
                            function success(response) {
                                var priceList = response.data.priceList;
                                if (!priceList)
                                    throw "illegal state: ACE uiservice did not return any pricelist";

                                scope.ace.priceList = priceList;

                                scope.ace.paymentIntervalNames = response.data.paymentIntervalNames;

                                // prepare data as required
                                scope.ace.options.manufacturers = [ ];

                                var manufacturers = scope.ace.priceList.manufacturer;
                                for (var i = 0; i < manufacturers.length; i++) {
                                    var manufacturer = manufacturers[i];
                                    scope.ace.maps.manufacturers[manufacturer.manufacturerName] = manufacturer;
                                    scope.ace.options.manufacturers.push(manufacturer);

                                    for (var j = 0; j < manufacturer.deviceList.device.length; j++) {
                                        var device = manufacturer.deviceList.device[j];

                                        scope.ace.maps.devices[device.deviceId] = device;
                                    }
                                }

                                var insurancesClasses = scope.ace.priceList.insuranceClass;
                                for (var i = 0; i < insurancesClasses.length; i++)
                                    scope.ace.maps.insuranceClasses[insurancesClasses[i].id] = insurancesClasses[i];
                            },
                            scope.throwServiceResponseFault
                        );
                    },
                    next: function (scope) {
                        return [
                            { key: 'Partner.manufacturerName', value: scope.ace.selection.manufacturerName },
                            { key: 'Partner.modelName', value: scope.ace.maps.devices[scope.ace.selection.deviceId].modelName },
                            { key: 'Partner.deviceID', value: scope.ace.maps.devices[scope.ace.selection.deviceId].deviceId },
                            { key: 'Partner.deviceClassId', value: scope.ace.selection.tariff.deviceClassId },
                            { key: 'Partner.tariffId', value: scope.ace.selection.tariff.tariffId },
                            { key: 'Partner.insuranceClassId', value: scope.ace.selection.insuranceClassId },
                            { key: 'Partner.paymentInterval', value: scope.ace.selection.paymentInterval }
                        ];
                    }
                },
                orderselection: {
                    dialog: function (scope) {
                        scope.ace = { acceptTransfer: false };

                        scope.data.product.exemptedFromTax = 1; // with insurances we do not have vat (but insurance tax)
                    }
                }
            }

        }
    }]);